/// <reference path="./index.d.ts" />

import authApi from './modules/auth';
import configurationApi from './modules/configuration';
import securityApi from './modules/security';
import billingApi from './modules/billing';

const api = {
	auth: authApi,
	configuration: configurationApi,
	security: securityApi,
	billing: billingApi,
};

export default api;
